import { Dispatch } from 'react';
import { createContext } from 'use-context-selector';
import { PayloadAction } from 'typesafe-actions';
import { AliasState, AliasContextActionTypes } from './types';
import { defaultAliasState } from './defaultState';

const AliasContext = createContext<Partial<AliasState>>(defaultAliasState);
const AliasDispatchContext = createContext<Dispatch<PayloadAction<AliasContextActionTypes, any>> | undefined>(
  undefined,
);

export { AliasContext, AliasDispatchContext };
